import { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Card from "../Card";
import Title from "../Title";
import { ReactSortable } from "react-sortablejs";
import urlSlug from "url-slug";
import moment from 'moment';
import {
  Button,
  Divider,
  Space,
  Switch,
  Upload,
  Input,
  Radio,
  Select,
  Drawer,
  Col,
  Modal,
  Row,
  DatePicker,
  notification,
  Form,
  Tag,
} from "antd";
import CardList from "../CardList";
import { ReactComponent as IconOk } from "../../../Assets/Images/Backoffice/Ok.svg";
import { ReactComponent as IconCalendar } from "../../../Assets/Images/Backoffice/Calendar.svg";
import { ReactComponent as IconClose } from "../../../Assets/Images/Backoffice/Close.svg";
import { ReactComponent as IconEdit } from "../../../Assets/Images/Backoffice/Edit.svg";
import { ReactComponent as IconHours } from "../../../Assets/Images/Backoffice/Hours.svg";
import { ReactComponent as IconUpload } from "../../../Assets/Images/Backoffice/Upload.svg";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { EyeOutlined } from "@ant-design/icons";
import axios, { all } from "axios";
import ImageResize from "quill-image-resize-module-react";
Quill.register("modules/imageResize", ImageResize);

const { RangePicker } = DatePicker;
const { Dragger } = Upload;
const { TextArea } = Input;

// import { useDrag } from 'react-dnd'
// import { ItemTypes } from './Constants'

const WrapperCardList = styled.section`
  // display: flex;
  width: 100% !important;
  flex-direction: row;

  .datepicker {
    width: 200px;
    height: 45px;
    border: 1px solid rgb(128, 159, 184);
  }


  p {
    color: #c2c4d4;
    font-size: 14px;
    letter-spacing: 0px;
    line-height: 20px;
    margin-bottom: 0% !important;
    text-align: left;
  }

  .text {
    color: #809fb8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .regular-text {
    color: #000;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .text-small {
    color: #809fb8;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .css-dev-only-do-not-override-j0nf2s .text {
    margin-bottom: 0 !important;
  }

  .icon-close {
    cursor: pointer;
  }

  .action-edit {
    cursor: pointer;
    color: #494d7d;
  }

  .flex-wrap {
    flex-wrap: wrap !important;
  }
`;

const WrapperCardApresentacao = styled.section`
  display: flex;
  flex-direction: column;

  .text-preview-desc, .text-preview-desc p {
    font-size: 14px !important;
    color: #c2c4d4;
  }

  .space-dates .ant-space-item, .space-dates .ant-row {
    width: 100% !important;
  }

  .w-100 {
    width: 100%;
  }

  .datepicker-input {
    width: 100% !important;
    height: 45px !important; 
    border: 1px solid rgb(128, 159, 184) !important;
  }

  .justify-end {
    display: flex;
    justify-content: flex-end !important;
    width: 100%;
    align-items: baseline !important;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 20px;
  }

  .icon {
    width: 25px;
  }

  .size-eye svg {
    width: 25px;
  }

  .ant-upload-btn {
  min-height: 190px;
}

  .ant-radio-button-wrapper {
    height: 45px;
    border: 1px solid rgb(128, 159, 184);
  }

  .ant-radio-button-wrapper span {
    line-height: 45px; 
    font-size: 14px;s
  }
  .text {
    margin-bottom: 0% !important;
  }

  h4 {
    text-align: center;
    font: normal normal bold 20px/20px Roboto;
    letter-spacing: 0px;
    color: #050505;
  }
  

  .text {
    color: #809FB8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .center {
    text-align: center;
  }

  .ant-upload-wrapper .ant-upload-drag {
    max-height: -webkit-fill-available;
    height: 91%;
    display: flex;
    justify-content: center;
  }

  .ant-upload-wrapper .ant-upload-drag .ant-upload-btn  {
    height: -webkit-fill-available;
  }

  .div-sortable {
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
  }

  .div-sortable .ant-col {
    padding: 5px;
  }

  .div-apresentacao{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .cta {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 45px !important;
    line-height: 18px;

    i { margin: 0 3px; }

    a { text-decoration: none; }
  }

  


  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #FFF;
    }
  }
`;

const ContentFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 45px;
    line-height: 18px;

    i {
      margin: 0 3px;
    }
  }

  a {
    text-decoration: none;
  }
`;

var styles = {
  h6_label: {
    color: "#809FB8",
    fontFamily: "Roboto",
    fontSize: "15px",
    marginTop: "1%",
  },
  input_class_disabled: {
    marginBottom: "2%",
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    opacity: 0.6,
    pointerApresentacaos: "none",
  },
  input_class: {
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    width: "100%",
  },
  select_class: {
    borderRadius: "6px",
    height: "45px",
    color: "#0C1151",
    width: "100%",
  },
  textarea_class: {
    borderRadius: "6px",
    border: "1px solid #809FB8",
    color: "#0C1151",
  },
  switch_label: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "bold",
    height: "45px",
    borderRadius: "8px",
    padding: "0px 16px",
    color: "#809FB8",
    border: "1px solid #809FB8",
    textAlign: "center",
  },
  upload: {
    width: "100%",
  },
};

const CardHeader = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto auto;

`;

export default function CardApresentacoes(props) {
  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [fileApresentacaoList, setfileApresentacaoList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isCursoCongresso, setIsCursoCongresso] = useState(false);
  const [isFormacaoOnline, setIsFormacaoOnline] = useState(false);
  const [isCursoCongressoEdit, setIsCursoCongressoEdit] = useState(0);
  const [isFormacaoOnlineEdit, setIsFormacaoOnlineEdit] = useState(0);
  const [showApresentacaoDrawer, setShowApresentacaoDrawer] = useState(false);
  // editar Apresentacao
  const [fileApresentacaoListEdit, setfileApresentacaoListEdit] = useState([]);
  const [apresentacaoIdEdit, setapresentacaoIdEdit] = useState("");
  const [descricaoApresentacaoEdit, setDescricaoApresentacaoEdit] =
    useState("");
  const [imagemDestaqueEdit, setImagemDestaqueEdit] = useState("");
  const [idToRemove, setIdToRemove] = useState(false);
  const [titleToRemove, setTitleToRemove] = useState(false);
  const [removeApresentacaoModalOpen, setRemoveApresentacaoModalOpen] =
    useState(false);
      const [editModeDescricao, setEditModeDescricao] = useState(false);

  const [allItems, setAllItems] = useState([]);

  const [formacoesOnline, setFormacoesOnline] = useState([]);
  const [cursosCongressos, setCursosCongressos] = useState([]);

  const stringToDate = (dataStr) => {
    const [dia, mes, ano] = dataStr.split('/').map(Number);
    return new Date(ano, mes - 1, dia); // Meses são de 0 a 11
  };

  const handleApresentacoes = (allApresentacoes) => {
    let apresentacoesToShow = [];
    allApresentacoes?.map((apresentacao) => {
      if (apresentacao != null) {
        let criado_em = new Date(apresentacao.created_at);
        apresentacao.created_at = criado_em.toLocaleDateString();
        apresentacao.slug = urlSlug(apresentacao.titulo);
        apresentacao.slug += "-" + apresentacao.id;
        apresentacoesToShow.push(apresentacao);

        let status = 'published';
        let today = new Date();

        if (apresentacao.start_post?.length == 10) {
          let startPostDate = stringToDate(apresentacao.start_post);
          if (today < startPostDate) {
            status = 'scheduled';
          }
        }

        if (apresentacao.end_post?.length == 10) {
          let endPostDate = stringToDate(apresentacao.end_post);
          if (today > endPostDate) {
            status = 'expired';
          }
        }


        apresentacao.status = status;
      }
    });

    setCursosCongressos(apresentacoesToShow.filter((a) => { return a.curso_congresso == 1 }).sort((a, b) => a.ordem - b.ordem));
    setFormacoesOnline(apresentacoesToShow.filter((a) => { return a.formacao_online == 1 }).sort((a, b) => a.ordem - b.ordem));
  };

  useEffect(() => {
    fetch(`https://api.spap.pt/api/all-apresentacoes`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar apresentacoes");
        }
        return response.json();
      })
      .then((data) => {
        handleApresentacoes(data.apresentacoes);
      })
      .catch((error) => console.error(error));
  }, []);

  const [currentItemsApresentacao, setCurrentItemsApresentacao] = useState(
    allItems.slice(0, 2)
  );

  const [itemOffsetApresentacao, setItemOffsetApresentacao] = useState(0);
  const itemsPerPageApresentacao = 2;

  const handlePageApresentacao = (page) => {
    const newOffset = ((page - 1) * itemsPerPageApresentacao) % allItems.length;
    setItemOffsetApresentacao(newOffset);
  };

  useEffect(() => {
    const endOffset = itemOffsetApresentacao + itemsPerPageApresentacao;
    setCurrentItemsApresentacao(
      allItems.slice(itemOffsetApresentacao, endOffset)
    );
  }, [itemOffsetApresentacao, allItems]);

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 5,
    rtl: false,
  });

  const clickToApresentacaoDrawer = (item) => {
    console.log(item);
    setapresentacaoIdEdit(item.id);
    editForm.setFieldsValue({
      titulo: item.titulo,
      start_post: item.start_post?.length == 10 ? dayjs(item.start_post,'DD/MM/YYYY') : null,
      end_post: item.end_post?.length == 10 ? dayjs(item.end_post,'DD/MM/YYYY') : null,
      start_event: item.start_event?.length == 10 ? dayjs(item.start_event,'DD/MM/YYYY') : null,
      end_event: item.end_event?.length == 10 ? dayjs(item.end_event,'DD/MM/YYYY') : null
    });
    setDescricaoApresentacaoEdit(item.descricao);
    setIsFormacaoOnlineEdit(item.formacao_online);
    setIsCursoCongressoEdit(item.curso_congresso);
    setImagemDestaqueEdit(item.imagem_destaque);
    setShowApresentacaoDrawer(true);
  };

  const propApresentacao = {
    onRemove: (file) => {
      const index = fileApresentacaoList.indexOf(file);
      const newfileApresentacaoList = fileApresentacaoList.slice();
      newfileApresentacaoList.splice(index, 1);
      setfileApresentacaoList(newfileApresentacaoList);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });

        return isImage || Upload.LIST_IGNORE;
      }
      setfileApresentacaoList([...fileApresentacaoList, file]);
      return false;
    },
    fileApresentacaoList,
  };

  const t = 1;
  const data = [];

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
    imageResize: {
      // parchment: Quill.import('parchment'),
      modules: ["Resize", "DisplaySize"],
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    'align',
    "link",
    "image",
    "video",
  ];

  const editDescricao = () => {
    setDescricaoApresentacaoEdit(descricaoApresentacaoEdit);
    setEditModeDescricao(true);
  };


  const handleApresentacao = (e) => {
    let startPost = e.start_post ? e.start_post.format('DD/MM/YYYY') : null;
    let endPost = e.end_post ? e.end_post.format('DD/MM/YYYY') : null;
    let startEvent = e.start_event ? e.start_event.format('DD/MM/YYYY') : null;
    let endEvent = e.end_event ? e.end_event.format('DD/MM/YYYY') : null;

    if (!isCursoCongresso && !isFormacaoOnline) {
      notification.warning({
        description:
          'Indique se pretende um "Curso e Congresso" ou uma "Formação Online".',
      });
      return;
    }

    if (e.titulo.length == 0 || fileApresentacaoList.length == 0) {
      notification.error({
        description:
          "Para criar uma novo, preencha todos os campos.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("titulo", e.titulo);
    formData.append("file", fileApresentacaoList[0]);
    formData.append("descricao", e.descricao);
    formData.append("start_post", startPost);
    formData.append("end_post", endPost);
    formData.append("start_event", startEvent);
    formData.append("end_event", endEvent);
    formData.append("external_link", e.external_link);
    formData.append("curso_congresso", isCursoCongresso ? 1 : 0);
    formData.append("formacao_online", isFormacaoOnline ? 1 : 0);

    // You can use any AJAX library you like
    fetch("https://api.spap.pt/api/admin/store-apresentacao", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            if (data.message == "already_exists") {
              notification.error({
                description:
                  "Já existe uma publicação com o mesmo nome.",
              });
            } else {
              form.resetFields();
              setfileApresentacaoList([]);
              handleApresentacoes(data.apresentacoes);
              notification.success({
                description: "A publicação foi criada com sucesso!",
              });
            }
          })
          .catch((err) => {});
      })
      .then(() => {})
      .catch(() => {})
      .finally(() => {});
  };

  const propApresentacaoEdit = {
    onRemove: (file) => {
      fileApresentacaoListEdit([]);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });
        setfileApresentacaoListEdit((current) => []);
        return Upload.LIST_IGNORE;
      }
      setfileApresentacaoListEdit([...fileApresentacaoListEdit, file]);
    },
    fileApresentacaoListEdit,
  };

  const handleEditApresentacao = (e) => {

    let startPost = e.start_post ? e.start_post.format('DD/MM/YYYY') : null;
    let endPost = e.end_post ? e.end_post.format('DD/MM/YYYY') : null;
    let startEvent = e.start_event ? e.start_event.format('DD/MM/YYYY') : null;
    let endEvent = e.end_event ? e.end_event.format('DD/MM/YYYY') : null;

    if (!isCursoCongressoEdit && !isFormacaoOnlineEdit) {
      notification.warning({
        description:
          'Indique se pretende um "Curso e Congresso" ou uma "Formação Online".',
      });
      return;
    }

    if (e.titulo.length == 0 || descricaoApresentacaoEdit.length == 0) {
      notification.error({
        description:
          "Para criar uma novo, preencha todos os campos.",
      });
      return;
    }

    const formData = new FormData();

    if (fileApresentacaoListEdit.length) {
      formData.append("file", fileApresentacaoListEdit[0]);
    }

    formData.append("apresentacaoId", apresentacaoIdEdit);
    formData.append("titulo", e.titulo);
    formData.append("descricao", descricaoApresentacaoEdit);
    formData.append("start_post", startPost);
    formData.append("end_post", endPost);
    formData.append("start_event", startEvent);
    formData.append("end_event", endEvent);
    formData.append("external_link", e.external_link);
    formData.append("curso_congresso", isCursoCongressoEdit ? 1 : 0);
    formData.append("formacao_online", isFormacaoOnlineEdit ? 1 : 0);

    setUploading(true);

    // You can use any AJAX library you
    fetch("https://api.spap.pt/api/admin/update-apresentacao", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            setShowApresentacaoDrawer(false);
            handleApresentacoes(data.apresentacoes);
            setfileApresentacaoListEdit([]);
            notification.success({
              description: "A publicação foi atualizada com sucesso!",
            });
          })
      });
  };

  const handleRemoveApresentacao = () => {
    axios
      .post(
        "https://api.spap.pt/api/admin/remove-apresentacao",
        { idToRemove },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + session_storage.token,
          },
        }
      )
      .then((res) => {
        setIdToRemove("");
        setRemoveApresentacaoModalOpen(false);
        if (res.status == 200) {
          session_storage.all_data.apresentacoes = res.data.apresentacoes;
          localStorage.setItem("session_data", JSON.stringify(session_storage));
          handleApresentacoes(res.data.apresentacoes);
          notification.success({
            description: "A apresentação foi removida com sucesso!",
          });
        }
      })
      .catch((error) => {
        // notification.error({description: 'Erro ao remover a imagem da galeria! Tente novamente.'});
      });
  };

  const openRemoveApresentacaoModal = (id, titulo) => {
    setIdToRemove(id);
    setTitleToRemove(titulo);
    setRemoveApresentacaoModalOpen(true);
  };

  const handleOrdem = (array, tipo) => {
    let ordemapresentacoes = [];
    array.map(function (item, index) {
      ordemapresentacoes.push({ ordem: index, id: item.id });
    });

    if (tipo == "formacoes") {
      setFormacoesOnline(array);
    } else {
      setCursosCongressos(array);
    }

    var bodyFormData = new FormData();

    bodyFormData.append("array", JSON.stringify(ordemapresentacoes));

    fetch("https://api.spap.pt/api/admin/set-ordem-apresentacao", {
      method: "POST",
      body: bodyFormData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        // handleApresentacoes(data.apresentacoes);
      });
    });
  };


  return (
    <WrapperCardApresentacao>
      <Card>

        <Form form={form} onFinish={handleApresentacao} className="edit-post-form">
        <CardHeader>
          <Row align={'middle'}>
            <Col span={8}>
              <Title>"Cursos e congressos" ou "Formação Online"</Title>

        <p className="text">
          Ambos disponíveis para consultar na página Formação
        </p>
            </Col>
            <Col span={16} align="right">
              <Space size={20}
                className="justify-end"
                align={'middle'}
              >
                <Space size={20}>
                    <Space>
                      <span className="regular-text">Curso e Congresso</span>
                      {isCursoCongresso == 1 || isCursoCongresso == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsCursoCongresso(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch onChange={(e) => setIsCursoCongresso(e)} />
                        </>
                      )}
                    </Space>
                    <Space>
                      <span className="regular-text">Formação Online</span>
                      {isFormacaoOnline == 1 ||
                      isFormacaoOnline == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsFormacaoOnline(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch onChange={(e) => setIsFormacaoOnline(e)} />
                        </>
                      )}
                    </Space>
                </Space>
                <Space
                  className="justify-end w-100 "
                >
                  <Form.Item
                    name='start_post'
                    style={{width: '100%'}}
                  >
                    <DatePicker 
                          placement="bottomRight"
                          className="datepicker-input"
                          format={"DD/MM/YYYY"}
                          placeholder="Data de Publicação"
                    />
                  </Form.Item>
                  <Form.Item
                    name='end_post'
                    style={{width: '100%'}}
                  >
                    <DatePicker 
                          placement="bottomRight"
                          className="datepicker-input"
                          format={"DD/MM/YYYY"}
                          placeholder="Data de Expiração"
                    />
                  </Form.Item>
                </Space>
              </Space>
            </Col>
          </Row>
        </CardHeader>
        <Divider style={{ margin: "12px 0" }}/>
          <Row gutter={[12, 18]} align="bottom" justify={'space-between'}>
            <Col span={15}>
              <label className="text">Título</label>
              <Form.Item
                name='titulo'
                rules={[{ required: true, message: 'O título é obrigatório' }]}
                style={{width: '100%'}}
              >
                <Input
                  placeholder="Título"
                  style={styles.input_class}
                />
              </Form.Item>
            </Col>
            <Col span={7} align="right" className="w-100">
              <Space
                className="justify-end w-100 space-dates"
              >
                <Space direction="vertical" align="start" size={0} className="w-100">
                  <label className="text">Início</label>
                  <Form.Item
                    name='start_event'
                    style={{width: '100%'}}
                  >
                    <DatePicker 
                      placement="bottomRight"
                      className="datepicker-input"
                      format={"DD/MM/YYYY"}
                      placeholder="Início"
                      />
                  </Form.Item>
                </Space>
                <Space direction="vertical" align="start" size={0}>
                  <label className="text">Fim</label>
                  <Form.Item
                    name='end_event'
                    style={{width: '100%'}}
                  >
                    <DatePicker 
                      placement="bottomRight"
                      className="datepicker-input"
                      format={"DD/MM/YYYY"}
                      placeholder="Fim"
                      />
                  </Form.Item>
                  </Space>
              </Space>
            </Col>
          </Row>
          <Row gutter={[12, 12]} align={"top"}>
            <Col span={6}>
              <p className="text" style={{ marginBottom: "0px" }} align="center">
                Tamanho máximo de upload (1 MB)
              </p>
              <Dragger
                {...propApresentacao}
                style={{ height: "100%" }}
                fileList={[...fileApresentacaoList]}
              >
                <p className="ant-upload-drag-icon">
                  <IconUpload />
                </p>
                <p className="ant-upload-text text">
                  Upload da imagem
                </p>
                <p className="ant-upload-hint">Faça Drag and drop aqui</p>
              </Dragger>
            </Col>
            <Col span={18}>
              <label className="text" style={{ marginBottom: "0px" }}>
                Descrição
              </label>
              <Form.Item
                name="descricao"
                style={{width: '100%'}}
              >
                <ReactQuill
                  placeholder="Descrição"
                  modules={modules}
                  formats={formats}
                  theme="snow"
                  name="descricao"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
          <Col span={24}>
            <label className="text">Link externo</label>
            <Form.Item
              name='external_link'
              style={{width: '100%'}}
            >
              <Input
                placeholder="Link externo (https://...)"
                style={styles.input_class}
              />
            </Form.Item>
          </Col>
          </Row>          
          <Divider style={{ margin: "12px 0" }} />
          <Row justify={'end'}>
            <Button
              type="primary"
              className="cta publish"
              htmlType='submit' 
              align="end"
            >
              Publicar <IconOk className="icon icon-ok" />
            </Button>
          </Row>
        </Form>
      </Card>
      <WrapperCardList>
        <Divider>Cursos e Congressos</Divider>
        {cursosCongressos?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem apresentações disponíveis.
          </p>
        )}
        {cursosCongressos?.length > 0 && (
          <>
            <ReactSortable
              list={cursosCongressos}
              setList={(e) => handleOrdem(e, "apresentacoes")}
              className="div-sortable"
            >
              {cursosCongressos.map((item, index) => {
                let textPreview = item?.descricao
  ?.replace(/<[^>]*>/g, '') // Remove todas as tags HTML
  .slice(0, 140);  
                if (item.descricao.length > 140) textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"apresentacoes-" + item.id}
                      className="div-apresentacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemoveApresentacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        <div
                          className="text-preview-desc"
                          dangerouslySetInnerHTML={{ __html: textPreview }}
                        ></div>
                      </div>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Apresentacao-" + index}
                              onClick={() => clickToApresentacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                              
                            </Space>
                            
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>

                            { item.status == 'published' && 
                            <Tag color="green">Publicado</Tag>}
                            { item.status == 'expired' && 
                            <Tag color="red">Expirado</Tag>}
                            { item.status == 'scheduled' && 
                            <Tag color="blue">Agendado para {item.start_post}</Tag>}
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "https://spap.pt/ferramentas-uteis/formacao/cursos-congressos/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Divider>Formações Online</Divider>
        {formacoesOnline?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem apresentações disponíveis.
          </p>
        )}
        {formacoesOnline?.length > 0 && (
          <>
            <ReactSortable
              list={formacoesOnline}
              setList={(e) => handleOrdem(e, "formacoes")}
              className="div-sortable"
            >
              {formacoesOnline.map((item, index) => {
                let textPreview = item?.descricao?.replace(/<(h2|h3|img|b|strong)[^>]*>/g, "<p>").slice(0, 100);
                if (item.descricao.length > 120) textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"apresentacoes-" + item.id}
                      className="div-apresentacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemoveApresentacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        <div
                          className="text-preview-desc"
                          style={{ fontSize: "12px", lineHeight: "1.4", color: 'rgb(194, 196, 212)' }}
                          dangerouslySetInnerHTML={{ __html: textPreview }}
                        ></div>
                      </div>
                      
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Apresentacao-" + index}
                              onClick={() => clickToApresentacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                            </Space>
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>

                            { item.status == 'published' && 
                            <Tag color="green">Publicado</Tag>}
                            { item.status == 'expired' && 
                            <Tag color="red">Expirado</Tag>}
                            { item.status == 'scheduled' && 
                            <Tag color="blue">Agendado para {item.start_post}</Tag>}
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "http://spap.pt/ferramentas-uteis/formacao/formacao-online/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Drawer
          key={"editar-apresentacao-" + apresentacaoIdEdit}
          title="Editar Publicação"
          width={1200}
          onClose={() => setShowApresentacaoDrawer(false)}
          open={showApresentacaoDrawer}
          bodyStyle={{
            paddingTop: 15,
          }}
          extra={
            <Space>
              <Button onClick={() => setShowApresentacaoDrawer(false)}>
                Cancelar
              </Button>
              <Button
                onClick={() => editForm.submit()}
                type="submit"
                style={{
                  borderRadius: "6px",
                  background: "#494D7D",
                  color: "#fff",
                }}
              >
                Guardar
              </Button>
            </Space>
          }
        >
          <Form form={editForm} onFinish={handleEditApresentacao}>
            <Row justify={'space-between'} align={'middle'}>
                <Col className="d-flex gap-20">
                    <div className="d-flex gap-10">
                        <span className="regular-text">Curso e Congresso</span>
                        {isCursoCongressoEdit == 1 || isCursoCongressoEdit == true ? (
                          <>
                            {" "}
                            <Switch
                              checked
                              onChange={(e) => setIsCursoCongressoEdit(e)}
                            />
                          </>
                        ) : (
                          <>
                            <Switch onChange={(e) => setIsCursoCongressoEdit(e)} />
                          </>
                        )}
                    </div>
                    <div className="d-flex gap-10">
                      <span className="regular-text">Formação Online</span>
                      {isFormacaoOnlineEdit == 1 ||
                      isFormacaoOnlineEdit == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsFormacaoOnlineEdit(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch onChange={(e) => setIsFormacaoOnlineEdit(e)} />
                        </>
                      )}
                    </div>
                </Col>
                <Col>
                  <Space
                    className="justify-end h-45"
                  >
                    <Form.Item
                      name='start_post'
                      style={{width: '100%'}}
                    >
                      <DatePicker 
                            placement="bottomRight"
                            className="datepicker-input"
                            format={"DD/MM/YYYY"}
                            placeholder="Data de Publicação"
                      />
                    </Form.Item>
                    <Form.Item
                      name='end_post'
                      style={{width: '100%'}}
                    >
                      <DatePicker 
                            placement="bottomRight"
                            className="datepicker-input"
                            format={"DD/MM/YYYY"}
                            placeholder="Data de Expiração"
                      />
                    </Form.Item>
                  </Space>
                </Col>
            </Row>
            <Divider
              style={{ background: "#fff", margin: "12px 0" }}
            ></Divider>
            <Col>
              <Row align={"middle"}>
                <Col span={12}>
                  <h5 style={{ marginBottom: "10px", fontSize: "18px" }}>
                    Upload da imagem
                  </h5>
                  <p>
                    Poderá fazer o upload de uma nova imagem de destaque
                    clicando na imagem do lado direito.
                  </p>
                </Col>
                <Col span={12}>
                  <Dragger
                    {...propApresentacaoEdit}
                    fileList={[...fileApresentacaoListEdit]}
                    style={{
                      marginBottom: "5px",
                      width: "100%",
                      backgroundImage:
                        "url(https://api.spap.pt/apresentacoes/" +
                        apresentacaoIdEdit +
                        "/" +
                        imagemDestaqueEdit +
                        ")",
                      backgroundSize: "cover",
                    }}
                  >
                    <div style={{ opacity: 0 }}>
                      <p className="ant-upload-drag-icon">
                        <IconUpload />
                      </p>
                      <p className="ant-upload-text text">Upload da imagem </p>
                      <p className="ant-upload-hint">Faça Drag and drop aqui</p>
                    </div>
                  </Dragger>
                </Col>
              </Row>
              <Divider
                style={{ background: "#fff", margin: "12px 0" }}
              ></Divider>
              
              <Row justify={'space-between'} align={'bottom'}>
                <Col span={13}>
                  <h6 style={styles.h6_label}>Título</h6>
                  <Form.Item
                    name='titulo'
                    style={{width: '100%'}}
                  >
                    <Input
                      key={"titulo-apresentacao-" + apresentacaoIdEdit}
                      placeholder="Título"
                      style={styles.input_class}
                      required
                    />
                  </Form.Item>
                </Col>
                <Col className="col-dates">
                  <Space
                    className="justify-end w-100"
                  >
                    <div>
                      <h6 style={styles.h6_label}>Início</h6>
                    <Form.Item
                      name='start_event'
                      style={{width: '100%'}}
                    >
                      <DatePicker 
                        placement="bottomRight"
                        className="datepicker-input"
                        format={"DD/MM/YYYY"}
                        placeholder="Data de Início"
                      />
                    </Form.Item>
                    </div>
                    <div>
                      <h6 style={styles.h6_label}>Fim</h6>
                    <Form.Item
                      name='end_event'
                      style={{width: '100%'}}
                    >
                      <DatePicker 
                            placement="bottomRight"
                            className="datepicker-input"
                            format={"DD/MM/YYYY"}
                            placeholder="Data de Fim"
                      />
                    </Form.Item>
                    </div>
                  </Space>
                </Col>
                <Col span={24}>
                  <h6 style={styles.h6_label}>Link externo</h6>
                  <Form.Item
                    name='external_link'
                    style={{width: '100%'}}
                  >
                    <Input
                      placeholder="Link externo (https://...)"
                      style={styles.input_class}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <h6 style={styles.h6_label}>Descrição</h6>
                    {!editModeDescricao && (
                      <>
                        <Button onClick={() => editDescricao()}>Editar</Button>
                        <br />
                        <br />
                        <div
                          className="event__content"
                          dangerouslySetInnerHTML={{ __html: descricaoApresentacaoEdit }}
                        ></div>
                      </>
                    )}
                    {editModeDescricao && (
                      <ReactQuill
                        key={"descricao-apresentacao-" + apresentacaoIdEdit}
                        modules={modules}
                        formats={formats}
                        value={descricaoApresentacaoEdit}
                        onChange={setDescricaoApresentacaoEdit}
                        theme="snow"
                      />
                    )}
                </Col>
              </Row>
            </Col>
          </Form>
        </Drawer>

        <Modal
          key={"remove-apresentacao-" + idToRemove}
          title="Está prestes a eliminar um Apresentacao"
          open={removeApresentacaoModalOpen}
          onOk={handleRemoveApresentacao}
          onCancel={() => setRemoveApresentacaoModalOpen(false)}
          okText="Confirmar"
          cancelText="Cancelar"
        >
          <p>
            Tem a certeza que pretende remover o Apresentacao{" "}
            <b>'{titleToRemove}'</b>?
          </p>
        </Modal>
      </WrapperCardList>
    </WrapperCardApresentacao>
  );
}
